import { render, staticRenderFns } from "./ViewTelaOpcoes.vue?vue&type=template&id=33b50134&scoped=true"
import script from "./ViewTelaOpcoes.vue?vue&type=script&lang=js"
export * from "./ViewTelaOpcoes.vue?vue&type=script&lang=js"
import style0 from "./ViewTelaOpcoes.vue?vue&type=style&index=0&id=33b50134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b50134",
  null
  
)

export default component.exports